import React from 'react';
import DrawerBox from './drawer-content';
import Calculator from './calculator';
import EnCalculator from './en-calculator';
import { useTranslation } from 'react-i18next';

interface IProps {
    visible: boolean;
    closed: () => void;
}

const Index = (props: IProps) => {
    const { i18n } = useTranslation();
    const isEn = i18n.language === 'en';
    return (
        <DrawerBox wrapClassName="sub-tiku__calc-self" visible={props.visible}>
            {isEn ? <EnCalculator closed={props.closed} /> : <Calculator closed={props.closed} />}
        </DrawerBox>
    );
};

export default Index;
